var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.1701 8.49V16.464C12.1701 17.412 12.4161 18.126 12.9081 18.606C13.4121 19.086 14.1081 19.326 14.9961 19.326C15.8961 19.326 16.5921 19.086 17.0841 18.606C17.5881 18.126 17.8401 17.412 17.8401 16.464V8.49H19.8921V16.428C19.8921 17.448 19.6701 18.312 19.2261 19.02C18.7821 19.728 18.1881 20.256 17.4441 20.604C16.7001 20.952 15.8781 21.126 14.9781 21.126C14.0781 21.126 13.2561 20.952 12.5121 20.604C11.7801 20.256 11.1981 19.728 10.7661 19.02C10.3341 18.312 10.1181 17.448 10.1181 16.428V8.49H12.1701Z",
  fill: "#FF6F6F"
});

function SvgIconUni(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUni);
export default __webpack_public_path__ + "static/media/Icon_Uni.cd96c227250152f9b8701ff207cab7c0.svg";
export { ForwardRef as ReactComponent };